module.exports = __webpack_public_path__ + "img/nr.1971c970.svg";